import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  getIcons(icons: string[], folder: string = '') {
    icons.forEach((icon) =>
      this.iconRegistry.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `/assets/icons${folder ? '/' + folder : ''}/${icon}.svg`
        )
      )
    );
  }

  addIcon(
    icon: string,
    defaultIconName: string,
    folder: 'tasks' | 'pratica-states' = 'tasks'
  ) {
    this.iconRegistry.addSvgIcon(
      defaultIconName,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `/assets/icons/${folder}/${defaultIconName}.svg`
      )
    );
    let iconName = icon;
    this.iconRegistry.addSvgIcon(
      iconName,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `/assets/icons/${folder}/${iconName}.svg`
      )
    );
    return this.iconRegistry.getNamedSvgIcon(iconName).pipe(
      map((res) => {
        if (!res) {
          console.error(`Error loading icon ${iconName}`);
          iconName = defaultIconName;
        }
        return iconName;
      }),
      catchError((err) => {
        console.warn(err);
        iconName = defaultIconName;
        return of(iconName);
      })
    );
  }
}
